import {
  getG11nAndTranslationsFromServer,
  initializeApollo,
  TCustomGetServerSideProps,
} from '@crehana/next';
import { getFeatureFlag } from '@crehana/utils';

import { LOGIN_PAGE_KEY } from '../constants';
import locales from '../i18n';
import { IAppProps } from '../types';

const getServerSideProps: TCustomGetServerSideProps<IAppProps> = async ({
  req,
}) => {
  const apolloClient = initializeApollo({
    headers: req.headers,
    pageKey: LOGIN_PAGE_KEY,
  });

  const [g11nData, hideFacebookButton, hideFacebookLink] = await Promise.all([
    getG11nAndTranslationsFromServer({
      apolloClient,
      headers: req.headers,
      pageKey: LOGIN_PAGE_KEY,
      defaultTranslations: locales,
      includeMainFooter: false,
      includeMainMenu: false,
    }),
    getFeatureFlag(apolloClient, 'button_facebook_auth_hide'),
    getFeatureFlag(apolloClient, 'link_facebook_auth_hide'),
  ]);

  return {
    props: {
      ...g11nData,
      featureFlags: {
        hideFacebookButton,
        hideFacebookLink,
      },
    },
  };
};

export default getServerSideProps;
